import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { CreateEventFromReservationsRequestDto } from "../generated/generatedTypes";
import { getApiErrorMessage } from "../getApiErrorMessage";

export const useCreateEventFromReservations = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateEventFromReservationsRequestDto): Promise<Response> => {
      const response = await apiFetch("api/admin/events", {
        method: "POST",
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        throw new Error(await getApiErrorMessage(response));
      }
      return response;
    },
    // Returning the promise keeps the mutation pending until the refetch finishes.
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: ["events"] }),
        queryClient.invalidateQueries({ queryKey: ["reservation-requests"] }),
      ]),
  });
};
